module.exports = __webpack_public_path__ + "static/media/polar-mint@3x.e03f466a.png";